import React, { useState } from 'react'
import Pagination from '../../Pagination/Pagination'
import { Grid } from '@material-ui/core'
import PartCard from '../../Part/PartCard'

const PartGrid = ({
  parts,
  setPartToEdit,
  setShowAddEditPart,
  setPartToDelete,
  setShowDeleteModal,
}) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(25)

  return (
    <>
      <Grid container spacing={2}>
        {(rowsPerPage > 0
          ? parts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          : parts
        ).map((part, index) => (
          <Grid key={index} item xs={3}>
            <PartCard
              part={part}
              setPartToEdit={setPartToEdit}
              setShowAddEditPart={setShowAddEditPart}
              setPartToDelete={setPartToDelete}
              setShowDeleteModal={setShowDeleteModal}
            />
          </Grid>
        ))}
      </Grid>

      <Pagination
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        rows={parts}
        className="m-t-40"
      />
    </>
  )
}

export default PartGrid
